define(['text!./templates/Title.html'], title => [() => ({
    restrict: 'E',
    replace: true,
    transclude: true,
    template: title,
    scope: {},
    link: ($scope, $element, $attrs) => {
        if ('offset' in $attrs) {
            $scope.hasOffset = true;
        }
    }
})]);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/titles/Title.js